import './products.css';
import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import recommendProductData from '../../data/recommend_product.json';
import React, { useState, useEffect } from 'react';

interface Product {
  product_id: number;
  product_name: string;
  product_image: string;
  shop_id: string;
  info_category: string;
  shop_url: string;
  comment: string;
}

export const Products: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true); // 表示状態を管理

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false); // 非表示にする
      setTimeout(() => {
        // アイテムを切り替える
        setCurrentIndex((prevIndex) => (prevIndex + 1) % recommendProductData.length);
        setIsVisible(true); // 再表示する
      }, 500); // 非表示から表示までの遅延（アニメーションの時間）
    }, 7000); // 7000ms (7秒) ごとに切り替え

    return () => clearInterval(interval); // クリーンアップ関数
  }, []);

  
  const nextProduct   = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % recommendProductData.length);
    setIsVisible(true);
  };
  const returnProduct   = () => {
    if(currentIndex !== 0){
      setCurrentIndex((prevIndex) => (prevIndex - 1) % recommendProductData.length);
      setIsVisible(true);
    }
  };

  const currentProduct = recommendProductData[currentIndex]; // 現在のアイテムを取得

  return (
    <>
      <Header />
      <main>
        <div className='contents-title-box'>
          <h3>おすすめ商品</h3>
        </div>
        <div className={`recommend-item-box ${isVisible ? 'visible' : 'hidden'}`}>
          <div className='recommend-item-img bg-color-back'>
            <img src={currentProduct.product_image} alt='Product Image' />
          </div>
          <div className='recommend-item-text bg-color-back'>
            <div className='recommend-item-shop'>
              {currentProduct.shop_id === "crocco" ? (
                <img src='img/product/crocco-shop-logo.png' alt='Shop Logo' />
              ) : (
                <img src='img/product/nomunomono.png' alt='Shop Logo' />
              )}
            </div>
            <div className='recommend-item-title'>
              <h4 className='f-color-base'>{currentProduct.product_name}</h4>
              <p>{currentProduct.comment}</p>
            </div>
            <a href={currentProduct.shop_url} target="_blank" rel="noopener noreferrer">
              <div className='btn-box'>
                <img src='img/shop.png' alt='shop' />
                <div className='btn-title'>
                  <h2>ONLINE SHOP</h2>
                  <p>お買い物をする</p>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className='product-control-box'>
          <div className='product-control-return-allow bg-color-main' onClick={returnProduct}/>
          <p className='f-color-base'>{currentIndex + 1} / {recommendProductData.length}</p>
          <div className='product-control-next-allow bg-color-main' onClick={nextProduct}/>
        </div>
      </main>
      <Footer />
    </>
  );
};
